<template>
  <Preloader />
</template>

<script>
import Preloader from '../components/Preloader.vue';
import User from '../orm/models/User/User';

export default {
  name: 'Logout',
  components: { Preloader },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.logout();
    });
  },
  methods: {
    async logout() {
      try {
        this.$echo.disconnect();
        await User.api().logout();
      } catch (e) {
        console.error(e);
      } finally {
        await this.$store.dispatch('entities/deleteAll');
        sessionStorage.setItem('skipAuthBootstrap', '1');
        window.location.replace('/login');
      }
    },
  },
};
</script>
